import axios from 'axios'

// The browser keeps a login token until it is told otherwise, but the backend stops accepting it once it expires.
// This keeps the two in step: when the backend refuses the stored token, the browser forgets it, so the site stops
// behaving as though the visitor were still logged in.

const EXPIRED_FLAG = 'loginExpired';
export const SESSION_ENDED_EVENT = 'clomp-session-ended';

// Forget the stored login. With expired set, the login page will say that the login ran out.
export function endSession(expired) {
    localStorage.removeItem('token');
    try {
        // what was remembered about the old login (such as whether to show the Admin link)
        Object.keys(sessionStorage).filter((key) => key.startsWith('adminAccess:')).forEach((key) => sessionStorage.removeItem(key));
        if (expired) {
            sessionStorage.setItem(EXPIRED_FLAG, 'yes');
        }
    } catch (e) { /* storage unavailable */ }
    window.dispatchEvent(new Event(SESSION_ENDED_EVENT));
}

// Whether a login has run out since this was last asked (asking clears it)
export function takeLoginExpired() {
    try {
        let expired = sessionStorage.getItem(EXPIRED_FLAG) === 'yes';
        sessionStorage.removeItem(EXPIRED_FLAG);
        return expired;
    } catch (e) {
        return false;
    }
}

// Any request sent with the stored token that comes back "401 not logged in" means that token is no longer good
axios.interceptors.response.use((response) => response, (error) => {
    let token = localStorage.getItem('token');
    let sent = error.config && error.config.headers && (error.config.headers.Authorization || error.config.headers.authorization);
    if (error.response && error.response.status === 401 && token !== null && sent === `Bearer ${token}`) {
        endSession(true);
    }
    return Promise.reject(error);
});
